import {
  IStyleFlexAlign,
  IStyleFontAlign,
  IStyleLength
} from '../interfaces/styles'

/**
 * Returns the correct css style unit value if value is a number
 * @param value
 * @param unit
 * @returns
 */
export function getUnitValue(value: IStyleLength = 0, unit: string = 'px') {
  if (typeof value === 'number') {
    return `${value}${unit}`
  }
  return value
}

/**
 * Returns a valid flex alignment in cases where font alignments are used
 * @param value
 */
export function getFlexValue(
  value: IStyleFontAlign | IStyleFlexAlign = 'start'
) {
  switch (value) {
    case 'right':
    case 'end': {
      return 'flex-end'
    }
    case 'left':
    case 'start': {
      return 'flex-start'
    }
    case 'justify': {
      return 'stretch'
    }
    default: {
      return value
    }
  }
}

/**
 * Returns a valid grid alignment in cases where font alignments are used
 * @param value
 */
export function getGridValue(
  value: IStyleFontAlign | IStyleFlexAlign = 'start'
) {
  switch (value) {
    case 'right': {
      return 'end'
    }
    case 'left': {
      return 'start'
    }
    case 'justify': {
      return 'stretch'
    }
    default: {
      return value
    }
  }
}
